export const useTresholdComparision = (score_A: string, score_B: string) => {
    const scoreAFormatted = Number(score_A)
    const scoreBFormatted = Number(score_B)

    if (scoreAFormatted == scoreBFormatted || typeof scoreAFormatted !== 'number' || typeof scoreBFormatted !== 'number') {
        return 'i-lucide-move-horizontal'
    }
    if (scoreAFormatted < scoreBFormatted) {
        return 'i-lucide-move-up'
    }
    if (scoreAFormatted > scoreBFormatted) {
        return 'i-lucide-move-down'
    }

    return 'i-lucide-circle-help'
}
